<template>
  <el-dialog
    :visible.sync="visible"
    title="投标文件退回"
    width="800px"
    :close-on-click-modal="false"
    class="dialog"
    append-to-body
  >
    <div class="dialog-body">
      <template v-if="readOnly">
        <p>
          您已对{{
            bidder.supplierName
          }}供应商的投标文件进行退回操作，退回后无法撤回
        </p>
        <el-form label-suffix="：">
          <el-form-item label="文件退回原因">
            <span>{{ bidder.backRemark }}</span>
          </el-form-item>
        </el-form>
      </template>

      <template v-else>
        <p>
          您将对{{
            bidder.supplierName
          }}供应商的投标文件进行退回操作，退回后将无法撤回，请谨慎操作！
        </p>
        <el-form ref="form" :model="form" :rules="rules" label-suffix="：">
          <el-form-item label="文件退回原因" prop="backRemark">
            <el-input
              v-model="form.backRemark"
              placeholder="请输入内容"
              type="textarea"
              :rows="3"
              maxlength="200"
            />
          </el-form-item>
          <el-form-item>
            <div class="operation">
              <el-button @click="cancel">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </div>
          </el-form-item>
        </el-form>
      </template>
    </div>
  </el-dialog>
</template>

<script>
import { requiredRule } from '@/utils/form-validate'
import { rejectQuoteOpenFileApi } from '@/api/hall/quote-open'
import useFileDecrypt from '@/components/kpb/hooks/useFileDecrypt'
import { bidFileTypeDict } from '@/dictionary/project/kpb-project'
import { workbenchServiceDict } from '@/dictionary/system'

export default {
  name: 'QuoteFileReturnDialog',

  props: {
    projectId: {
      type: [String, Number],
      default: 0
    },

    bidder: {
      type: Object,
      default: () => {}
    },

    readOnly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: false,

      form: {
        backRemark: ''
      },
      rules: {
        backRemark: requiredRule('请填写文件退回原因')
      }
    }
  },

  methods: {
    // 页面事件
    cancel() {
      this.closeDialog()
    },

    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }

        useFileDecrypt(
          workbenchServiceDict.PURCHASER.alias,
          this.projectId,
          bidFileTypeDict.QUOTATION.value
        )
          .rejectQuoteFile(this.bidder.bidderId, this.form)
          .then(() => {
            this.$message.success('文件退回成功')
            this.closeDialog()
          })
          .catch(err => {
            if (err?.message) this.$message.error(err.message)
          })
      })
    },

    closeDialog() {
      this.visible = false
      this.$refs.form.resetFields()
      this.$refs.form.clearValidate()
      this.$emit('closeDialog')
    }
  }
}
</script>

<style scoped lang="scss">
.dialog {
  ::v-deep .el-dialog__body {
    padding: 16px 32px;
  }

  .operation {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
}
</style>
